import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';

// @material-ui/icons
import AccountCircle from '@material-ui/icons/AccountCircle';

// core components
import * as actions from '../../reducers/User/actions';
import Button from '../CustomButtons/Button';
import headerLinksStyle from '../../assets/jss/material-dashboard-pro-react/components/headerLinksStyle';
import { historyPropTypes } from '../../types';

class HeaderLinks extends Component {
  state = {
    open: false,
  };

  handleClick = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleLogout = () => {
    const { history, logout } = this.props;

    logout().then(() => {
      history.push('/pages/login');
    });

    this.handleClose();
  };

  render() {
    const { classes } = this.props;
    const { open } = this.state;
    const dropdownItem = classNames(classes.dropdownItem, classes.infoHover);

    return (
      <Fragment>
        <Button
          data-testid="button-header-user"
          color="transparent"
          justIcon
          aria-label="Notifications"
          aria-owns={open ? 'menu-list' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          buttonRef={(node) => {
            this.anchorEl = node;
          }}
        >
          <AccountCircle className={`${classes.headerLinksSvg} ${classes.links}`} />
        </Button>
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          transition
          disablePortal
          placement="bottom"
          className={classNames({
            [classes.popperClose]: !open,
          })}
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} id="menu-list" style={{ transformOrigin: '0 0 0' }}>
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={this.handleClose}>
                  <MenuList role="menu">
                    <MenuItem data-testid="button-header-logout" onClick={this.handleLogout} className={dropdownItem}>
                      Logout
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Fragment>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  history: historyPropTypes.isRequired,
  logout : PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(actions.logout()),
});

export default compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
  withRouter,
  withStyles(headerLinksStyle),
)(HeaderLinks);
